export const FETCH_ACADEMIC_FAILURE = 'FETCH_ACADEMIC_FAILURE';
export const FETCH_ACADEMIC_REQUEST = 'FETCH_ACADEMIC_REQUEST';
export const FETCH_ACADEMIC_SUCCESS = 'FETCH_ACADEMIC_SUCCESS';

export const SAVE_ACADEMIC_FIELDS_FAILURE = 'SAVE_ACADEMIC_FIELDS_FAILURE';
export const SAVE_ACADEMIC_FIELDS_REQUEST = 'SAVE_ACADEMIC_FIELDS_REQUEST';
export const SAVE_ACADEMIC_FIELDS_SUCCESS = 'SAVE_ACADEMIC_FIELDS_SUCCESS';

export const ACADEMIC_ENTITY = 'academic';
